import { forEach, keyBy } from 'lodash';

export const getScorePart = (option: any, items: any, evaluations: any) => {

	//console.log('getScorePart', option, items, evaluations);
	let indexedEvaluations = keyBy(evaluations, 'itemId') || {};

	let total = 0;
	let count = 0;
	
	forEach(items, (s) => {
		let weight = s.weight;
		count += weight;
		
		total +=
			weight *
			(indexedEvaluations && indexedEvaluations[s.id] && indexedEvaluations[s.id].value !== undefined && indexedEvaluations[s.id].value !== null
				? indexedEvaluations[s.id].value
				: 50);
	});

	console.groupEnd();

	return count != 0 ? total / count : 50;
};

export const getOptionScore = (
	option: any,
	stakefactors: any,
	indicators: any,
	constraints: any,
	evaluationStakefactors: any,
	evaluationIndicators: any,
	evaluationConstraints: any
): Number => {
	let totalStakefactors = getScorePart(option, stakefactors, evaluationStakefactors);
	let totalIndicators = getScorePart(option, indicators, evaluationIndicators);
	let totalContraints = getScorePart(option, constraints, evaluationConstraints);

	console.log({
		totalStakefactors,
		totalIndicators,
		totalContraints,
	});

	return (totalStakefactors + totalIndicators + totalContraints) / 3;
};

export const getScoreColor = (value: number) => {
	let color2 = [231, 5, 73];
	let color1 = [0, 176, 169];

	var w1 = value / 100;
	var w2 = 1 - w1;
	var rgb = [
		Math.round(color1[0] * w1 + color2[0] * w2),
		Math.round(color1[1] * w1 + color2[1] * w2),
		Math.round(color1[2] * w1 + color2[2] * w2),
	];
	return 'rgb(' + rgb.join(',') + ')';
};

export const getItemScore = (item: any, evaluations: any) => {
	let indexedEvaluations = keyBy(evaluations, 'itemId') || {};

	if (indexedEvaluations[item.id]) return indexedEvaluations[item.id].value;

	return 50;
};
